import { render, staticRenderFns } from "./ProjectsForm.vue?vue&type=template&id=0ebd3e68&scoped=true"
import script from "./ProjectsForm.vue?vue&type=script&lang=js"
export * from "./ProjectsForm.vue?vue&type=script&lang=js"
import style0 from "./ProjectsForm.vue?vue&type=style&index=0&id=0ebd3e68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebd3e68",
  null
  
)

export default component.exports